<template>
    <div class="sbs-step">
        <div class="sbs-step__circle-wrapper">
            <div
                class="sbs-step__circle"
                :class="{
                    success: isChecked,
                    disabled: isDisabled,
                    ...stepClasses.reduce((obj, cls) => ({
                        ...obj,
                        [cls]: true,
                    }), {}),
                }">
                <SbsIcon
                    v-if="isChecked"
                    iconName="check"
                    class="icon-succes" />
                <span
                    v-else
                    class="sbs-step__number">{{ bulletText }}</span>
            </div>
        </div>

        <div
            class="sbs-step__label"
            :class="{ disabled: isDisabled }">
            {{ text }}
        </div>
    </div>
</template>

<script>
import SbsIcon from '../icon/SbsIcon.vue';
import themesMixin from '../../mixins/themes.js';

export default {
    name: 'SbsStep',
    components: {
        SbsIcon,
    },
    mixins: [themesMixin],
    data() {
        return {
        };
    },
    computed: {
        stepClasses() {
            const classes = [...this.themeClasses];

            return classes;
        },
    },
    props: {
        isChecked: Boolean,
        isDisabled: Boolean,
        text: {
            type: String,
            required: true,
        },
        bulletText: {
            type: String,
            default: 'name',
        },
    },
};
</script>

<style lang="scss">
.sbs-step {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__circle-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
    }

    &__circle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        color: #000000;
        border: 1px solid #0066ff;
        border-radius: 50%;

        .icon-succes {
            color: #ffffff;
            font-size: 17px;
        }
    }

    &__number {
        font-size: 17px;
    }

    &__label {
        max-width: 300px;
        margin-right: 10px;
        font-size: 12px;
        line-height: math.div(16, 12);

        @include line-clamp(3, math.div(16, 12));
    }
}

.success {
    &.sbs-step__circle {
        background: #0066ff;
    }
}

.disabled {
    &.sbs-step {
        &__circle {
            background: transparent;
            border: 1px solid #c4c6cd;
        }

        &__label {
            color: #c4c6cd;
        }
    }
}
</style>
